<template>
  <div class="dashboard">
    <template v-if="isAuth()">
      <div v-if="isLandlord()">
        <LandlordDashboard></LandlordDashboard>
      </div>
      <div v-else-if="isTenant()">
        <TenantDashboard></TenantDashboard>
      </div>
      <div v-else-if="isUser()">
        <EndUserDashboard></EndUserDashboard>
      </div>
      <div v-else>
        <NoRoleUserDashboard />
      </div>
    </template>
  </div>
</template>

<script>
import LandlordDashboard from 'landlord/MainView';
import TenantDashboard from 'src/components/tenant-dashboard/MainView';
import EndUserDashboard from 'end_user/MainView';
import NoRoleUserDashboard from 'no_role_user/MainView';

export default {
  components: {
    LandlordDashboard,
    TenantDashboard,
    EndUserDashboard,
    NoRoleUserDashboard,
  },
  data() {
    return {
    };
  },
};

</script>
<style lang="scss" scoped>
.dashboard {
  &__content {
    margin-top: 0;
  }
  &__mainview {
    background-color: inherit;
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Dashboard.vue